import {
  _get_web_push_public_key,
  _subscribe_web_push,
  _unsubscribe_web_push,
} from "./axios_services";

export const nativePushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const decodeVapidKey = (value) => {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((character) => character.charCodeAt(0)));
};

export const getNativePushSubscription = async () => {
  if (!nativePushSupported()) return null;
  const registration = await navigator.serviceWorker.ready;
  return registration.pushManager.getSubscription();
};

export const enableNativePush = async () => {
  if (!nativePushSupported()) throw new Error("Native notifications are not supported in this browser.");
  const keyResponse = await _get_web_push_public_key();
  const publicKey = keyResponse?.data?.publicKey;
  if (!publicKey) throw new Error("Native notifications are not configured yet.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission was not granted.");

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: decodeVapidKey(publicKey),
  });
  await _subscribe_web_push(subscription.toJSON());
  return subscription;
};

export const disableNativePush = async () => {
  const subscription = await getNativePushSubscription();
  if (!subscription) return;
  await _unsubscribe_web_push(subscription.endpoint);
  await subscription.unsubscribe();
};
